import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { ProgressIndicatorService, ProgressState, ProgressStage } from '../../../../shared/services/progress-indicator.service';

@Component({
  selector: 'app-progress-indicator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './statement-generation-progress.component.html',
  styleUrls: ['./statement-generation-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressIndicatorComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private hasBeenShown = false; // Track if we've shown this session

  progressState: ProgressState = {
    show: false,
    title: '',
    stages: [],
    currentStageIndex: 0,
    progress: 0,
    currentMessage: ''
  };

  isExpanded = false;

  constructor(
    private progressService: ProgressIndicatorService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.progressService.getState()
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        this.progressState = state;

        // Mark as shown when first displayed
        if (state.show && !this.hasBeenShown) {
          this.hasBeenShown = true;
          // Start minimized (isExpanded stays false)
        }

        // Reset when hidden
        if (!state.show) {
          this.hasBeenShown = false;
          this.isExpanded = false;
        }

        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onClose(): void {
    this.progressService.hide();
    this.isExpanded = false;
  }

  onMinimize(): void {
    this.isExpanded = false;
  }

  onExpand(): void {
    this.isExpanded = true;
  }

  getStageIcon(stage: ProgressStage): string {
    switch (stage.status) {
      case 'completed':
        return 'fa-check-circle';
      case 'in-progress':
        return 'fa-spinner fa-spin';
      case 'error':
        return 'fa-exclamation-circle';
      default:
        return 'fa-circle';
    }
  }

  getStageClass(stage: ProgressStage): string {
    switch (stage.status) {
      case 'completed':
        return 'text-green-600';
      case 'in-progress':
        return 'text-blue-600';
      case 'error':
        return 'text-red-600';
      default:
        return 'text-gray-400';
    }
  }
}
